"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewMonthlyPayWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_model_1 = require("@athena-portal/journey-model");
var journey_services_1 = require("@athena-portal/journey-services");
var commonFunctions_1 = require("../../commonFunctions");
var NewMonthlyPayWidget = /** @class */ (function (_super) {
    __extends(NewMonthlyPayWidget, _super);
    function NewMonthlyPayWidget(props) {
        return _super.call(this, props) || this;
    }
    NewMonthlyPayWidget.prototype.render = function () {
        var priceField = this.getSetting("priceField", undefined);
        var priceString = journey_services_1.ObjectManipulator.fetchFieldValue(priceField, this.props.interaction);
        return ((0, jsx_runtime_1.jsxs)("p", { className: "text-center my-2", children: ["Your new monthly pay will be ", (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: (0, commonFunctions_1.getAmountToDisplay)(priceString) })] }));
    };
    NewMonthlyPayWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "price", type: journey_model_1.TypeDescriptions.String },
        ]),
        __metadata("design:paramtypes", [Object])
    ], NewMonthlyPayWidget);
    return NewMonthlyPayWidget;
}(plugin_journey_1.WidgetBase));
exports.NewMonthlyPayWidget = NewMonthlyPayWidget;
//# sourceMappingURL=NewMonthlyPayWidget.js.map